export default __webpack_public_path__ + "images/cefe5d05-pending.svg";